import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var ButtonPlayCircleSvg = function ButtonPlayCircleSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.362 12.25 8.977 6.07v12.358zm-2.352 0-4.638 3.417V8.832z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2.249a10 10 0 1 0 0 20 10 10 0 0 0 0-20M5.916 6.165a8.605 8.605 0 1 1 12.168 12.168A8.605 8.605 0 0 1 5.916 6.165",
    clipRule: "evenodd"
  }));
};
export var ButtonPlayCircle = function ButtonPlayCircle(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: ButtonPlayCircleSvg
  }));
};